import CryptoJS from "crypto-js";
import CONSTANTS from "../utils/constants"

export const encrypt = (val:string) => {
    const secretKey = CryptoJS.enc.Utf8.parse(CONSTANTS.CRYPT.EncryptionSecretKey)
    const secretIv = CryptoJS.enc.Utf8.parse(CONSTANTS.CRYPT.getEncryptionSecretIv)
    const encryptedValue = CryptoJS.AES.encrypt(val, secretKey,{
      keySize: 128,
      iv: secretIv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    
    return encryptedValue.toString()
  };